export class Dog {
  constructor(
    public id: number,
    public name: string,
    public breed: string,
    public petTypeId: number,
    public gender: string,
    public dateOfBirth: Date,
    public imageUrl: string,
    public isCastrated: boolean
  ) { }
}
